import React from 'react';
import { connect } from 'react-redux';
import './index.css';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { openRequestModal } from '../../actions/modals';
import Button from '@material-ui/core/Button';
import { getAllCities } from './../../actions/li';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import MainImage from './../../resources/img/main-photo.webp';
import adv_img_1 from './../../resources/img/adv_img_1.jpg';
import adv_img_2 from './../../resources/img/adv_img_2.jpg';
import adv_img_3 from './../../resources/img/adv_img_3.jpg';
import adv_img_4 from './../../resources/img/adv_img_4.jpg';
import adv_img_5 from './../../resources/img/adv_img_5.jpg';
import adv_img_6 from './../../resources/img/adv_img_6.jpg';

import logo_1 from './../../resources/img/logo_1.png';
import logo_2 from './../../resources/img/logo_2.png';
import logo_3 from './../../resources/img/logo_3.png';
import logo_4 from './../../resources/img/logo_4.png';

import vk from '../../resources/img/vk.png';
import facebook from '../../resources/img/facebook.png';
import inst from '../../resources/img/inst.png';
import telegram from '../../resources/img/telegram.png';
import youtube from '../../resources/img/youtube.png';
import '../../resources/fonts/stylesheet.css';
import EnrollChildComponent from '../../components/EnrollChild';

import ReviewsComponent from './reviews';
import BenefitComponent from './benefit';

import footer_photo from './../../resources/img/footer_photo.png';

import Grid from '@material-ui/core/Grid';

class HomePage extends React.Component {
  componentDidMount() {
    this.props.getAllCities();
  }

  enrollKid = () => {
    const { t } = this.props;
    this.props.openRequestModal({
      opened: true,
      data: {
        header: t('form.enroll_child'),
        modaltype: 'EnrollChild',
      },
    });
  };

  openCallBack = () => {
    const { t } = this.props;
    this.props.openRequestModal({
      opened: true,
      data: {
        header: t('form.call_me'),
        modaltype: 'CallBack',
      },
    });
  };

  render() {
    const { t } = this.props;
    let domain =
      window.location.hostname.split('.')[
        window.location.hostname.split('.').length - 1
      ];
    // domain = "by";
    const schemaYouTube = {
      ua: 'https://www.youtube.com/embed/hHuQETukNMU',
      ru: 'https://www.youtube.com/embed/CJGXBWtRkQI',
      md: 'https://www.youtube.com/embed/akeA5Qpn92E',
      by: 'https://www.youtube.com/embed/wyp9tGA5LVU',
    };
    return (
      <>
        <section className="main_container">
          <Container fixed>
            <Grid container>
              <Grid item md={6} xs={12} className="mainTextBlock">
                <Typography
                  variant="h4"
                  component="h1"
                  className="main_block-title"
                >
                  {t('title')}
                </Typography>
                <Typography
                  variant="h6"
                  component="h2"
                  className="main_block-subtitle"
                >
                  {t('sub_title')}
                </Typography>
                <Button
                  className="mainContainerButton"
                  onClick={this.enrollKid}
                >
                  {t('sub_title_btn')}
                </Button>
              </Grid>
              <Grid item md={6} xs={12}>
                <div
                  style={{ backgroundImage: `url(${MainImage})` }}
                  className="mainPhoto"
                ></div>
              </Grid>
            </Grid>
          </Container>
        </section>
        <section className="heathy_summer" id="method">
          <Container fixed>
            <Grid container alignItems="center">
              <Grid item md={12} xs={12}>
                <Typography variant="h6" component="h3">
                  {t('heathy_summer.title')}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} className="verticalBlockCentred">
                <div className="healthy_blocks-vertical txt-green">
                  <h3>{t('heathy_summer.blocks.1.title')}</h3>
                  <ul>
                    <li>{t('heathy_summer.blocks.1.text_1')}</li>
                    <li>{t('heathy_summer.blocks.1.text_2')}</li>
                    <li>{t('heathy_summer.blocks.1.text_3')}</li>
                  </ul>
                </div>
                <div className="healthy_blocks-vertical">
                  <h3>{t('heathy_summer.blocks.2.title')}</h3>
                  <ul>
                    <li>{t('heathy_summer.blocks.2.text_1')}</li>
                    <li>{t('heathy_summer.blocks.2.text_2')}</li>
                    <li>{t('heathy_summer.blocks.2.text_3')}</li>
                    <li>{t('heathy_summer.blocks.2.text_4')}</li>
                  </ul>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="healthy_blocks-horizontal orange">
                  <h3>{t('heathy_summer.blocks.3.title')}</h3>
                  <p>{t('heathy_summer.blocks.3.text_1')}</p>
                </div>
                <div className="healthy_blocks-horizontal txt-green">
                  <h3>{t('heathy_summer.blocks.4.title')}</h3>
                  <p>{t('heathy_summer.blocks.4.text_1')}</p>
                  <p>{t('heathy_summer.blocks.4.text_2')}</p>
                  <Grid container>
                    <Grid item md={6}>
                      {t('heathy_summer.blocks.4.text_3')}
                    </Grid>
                    <Grid item md={6} className="btnBottom">
                      <Button
                        className="healthyButton"
                        onClick={this.openCallBack}
                      >
                        {t('heathy_summer.blocks.4.button')}
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </Container>
          <Typography variant="h6" component="h3" className="full-width">
            {t('heathy_summer.blocks.sub_block')}
          </Typography>
        </section>
        <BenefitComponent />
        <section className="advantages">
          <Container fixed>
            <Grid container>
              <Grid item md={6} xs={12}>
                <Grid container>
                  <Grid item md={12} xs={12}>
                    <h2 className="greenText">{t('advantages.title')}</h2>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <div className="adv_block">
                      <h3>{t('advantages.blocks.1.title')}</h3>
                      <p>{t('advantages.blocks.1.text')}</p>
                    </div>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <div className="adv_block green">
                      <h3>{t('advantages.blocks.2.title')}</h3>
                      <p>{t('advantages.blocks.2.text')}</p>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={6} xs={12}>
                <Grid container alignContent="center">
                  <Grid item md={6} className="verticalBlockCentred">
                    <div className="adv_block">
                      <h3>{t('advantages.blocks.3.title')}</h3>
                      <p>{t('advantages.blocks.3.text')}</p>
                    </div>
                  </Grid>
                  <Grid item md={6} xs={12} className="verticalBlockCentred">
                    <div className="adv_block green">
                      <h3>{t('advantages.blocks.4.title')}</h3>
                      <p>{t('advantages.blocks.4.text')}</p>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={6} xs={12}>
                <Grid container>
                  <Grid item md={6} xs={12}>
                    <div className="adv_block horizontal green">
                      <h3>{t('advantages.blocks.5.title')}</h3>
                      <p>{t('advantages.blocks.5.text')}</p>
                    </div>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <div className="adv_block horizontal">
                      <h3>{t('advantages.blocks.6.title')}</h3>
                      <p>{t('advantages.blocks.6.text')}</p>
                    </div>
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <div className="adv_block horizontal">
                      <h3>{t('advantages.blocks.7.title')}</h3>
                      <p>{t('advantages.blocks.7.text')}</p>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={6} xs={12}>
                <Grid container>
                  <Grid item md={12} xs={12}>
                    <div className="adv_block green">
                      <h3>{t('advantages.blocks.8.title')}</h3>
                      <p>{t('advantages.blocks.8.text')}</p>
                    </div>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <div className="adv_block horizontal green">
                      <h3>{t('advantages.blocks.9.title')}</h3>
                      <p>{t('advantages.blocks.9.text')}</p>
                    </div>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <div className="adv_block horizontal">
                      <h3>{t('advantages.blocks.10.title')}</h3>
                      <p>{t('advantages.blocks.10.text')}</p>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={12} xs={12}>
                <Grid container>
                  <Grid item md={3} xs={12}>
                    <div className="adv_block horizontal green">
                      <h3>{t('advantages.blocks.11.title')}</h3>
                      <p>{t('advantages.blocks.11.text')}</p>
                    </div>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <div className="adv_block horizontal">
                      <h3>{t('advantages.blocks.12.title')}</h3>
                      <p>{t('advantages.blocks.12.text')}</p>
                    </div>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <div className="adv_block green">
                      <h3>{t('advantages.blocks.13.title')}</h3>
                      <p>{t('advantages.blocks.13.text')}</p>
                    </div>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={12} id="gallery">
                <Typography
                  variant="h6"
                  component="h3"
                  className="full-width orange"
                >
                  {t('advantages.gallery_title')}
                </Typography>
              </Grid>
              <Grid container className="adv_images">
                <Grid item md={4} xs={12}>
                  <img alt="" src={adv_img_1} />
                </Grid>
                <Grid item md={4} xs={12}>
                  <img alt="" src={adv_img_2} />
                </Grid>
                <Grid item md={4} xs={12}>
                  <img alt="" src={adv_img_3} />
                </Grid>
                <Grid item md={4} xs={12}>
                  <img alt="" src={adv_img_4} />
                </Grid>
                <Grid item md={4} xs={12}>
                  <img alt="" src={adv_img_5} />
                </Grid>
                <Grid item md={4} xs={12}>
                  <img alt="" src={adv_img_6} />
                </Grid>
                <Grid item md={12} xs={12}>
                  <div
                    className="healthy_blocks-horizontal txt-green"
                    style={{ marginTop: '20px' }}
                  >
                    <p style={{ textAlign: 'center' }}>
                      {t('advantages.gallery_sub_title')}
                    </p>
                  </div>
                </Grid>
                <Grid item md={12} xs={12}>
                  <iframe
                    className="youtube_iframe"
                    height="699"
                    src={schemaYouTube[domain]}
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  ></iframe>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </section>
        <ReviewsComponent />
        <section className="what_will_be">
          <Container fixed>
            <Grid container>
              <Grid item md={12} xs={12}>
                <h2>{t('what_will_be.title')}</h2>
              </Grid>
              <Grid item md={3} xs={12}>
                <div className="will_be_block">
                  <img alt="" src={logo_1} />
                  <p>{t('what_will_be.blocks.1')}</p>
                </div>
              </Grid>
              <Grid item md={3} xs={12}>
                <div className="will_be_block">
                  <img alt="" src={logo_2} />
                  <p>{t('what_will_be.blocks.2')}</p>
                </div>
              </Grid>
              <Grid item md={3} xs={12}>
                <div className="will_be_block">
                  <img alt="" src={logo_3} />
                  <p>{t('what_will_be.blocks.3')}</p>
                </div>
              </Grid>
              <Grid item md={3} xs={12}>
                <div className="will_be_block">
                  <img alt="" src={logo_4} />
                  <p>{t('what_will_be.blocks.4')}</p>
                </div>
              </Grid>
            </Grid>
          </Container>
        </section>
        <section className="main_container footer">
          <Container fixed>
            <Grid container>
              <Grid item md={7} xs={12} className="desctopFooterPhoto">
                <div
                  style={{ backgroundImage: `url(${footer_photo})` }}
                  className="mainPhoto footer"
                ></div>
              </Grid>
              <Grid item md={5} className="footer_form" xs={12}>
                <h2>{t('footer.tutorial.title')}</h2>
                <ul>
                  <li>{t('footer.tutorial.text_1')}</li>
                  <li>
                    {t('footer.tutorial.text_2')}
                    {this.props.defaultCity && this.props.defaultCity.phones
                      ? this.props.defaultCity.phones.map((el, index) => {
                          return (
                            <div key={index} className="footerPhones">
                              <a
                                href={`tel:${el}`}
                                style={{ color: '#f88c38' }}
                              >
                                {el}
                              </a>
                            </div>
                          );
                        })
                      : null}
                  </li>
                </ul>
                <div className="footerForm">
                  <h3>{t('footer.form_title')}</h3>
                  <EnrollChildComponent />
                </div>
              </Grid>
              <Grid item xs={12} className="mobileFooterPhoto">
                <div
                  style={{ backgroundImage: `url(${footer_photo})` }}
                  className="mainPhoto footer"
                ></div>
              </Grid>
            </Grid>
          </Container>
        </section>
        <footer>
          <Container fixed>
            <Grid container className="socials">
              <div>
                <a
                  href={t('socials.fb')}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img alt="" src={facebook} />
                </a>
              </div>
              <div>
                <a
                  href={t('socials.inst')}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img alt="" src={inst} />
                </a>
              </div>
              {domain === 'ua' ? (
                <div>
                  <a
                    href={t('socials.tg')}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img alt="" src={telegram} />
                  </a>
                </div>
              ) : null}

              {domain === 'ru' || domain === 'by' ? (
                <div>
                  <a
                    href={t('socials.vk')}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img alt="" src={vk} />
                  </a>
                </div>
              ) : null}

              <div>
                <a
                  href={t('socials.yt')}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img alt="" src={youtube} />
                </a>
              </div>
            </Grid>
            <div className="copyright">
              <p>
                ©Copyright 2013-{new Date().getFullYear()} by Iurii Novosolov.
              </p>
              <p>
                {t('copyright.1')}
                <a
                  href="https://soroban.ua/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('copyright.2')}
                </a>
              </p>
              <p>{t('copyright.3')}</p>
            </div>
          </Container>
        </footer>
      </>
    );
  }
}

const widthConnect = connect(
  (state) => ({ defaultCity: state.cities && state.cities.defaultCity }),
  (dispatch) =>
    bindActionCreators({ openRequestModal, getAllCities }, dispatch),
);

export default withTranslation()(widthConnect(HomePage));
